/*
  Travas de navegador contra spam, para formulario com data-protecao.
  Hoje: variante licenciamento de sections/lojista-formulario.liquid.

  COMPLEMENTO, NAO PROTECAO. Quem segura spam de verdade e o hCaptcha nativo da
  Shopify no form 'contact'. Robo que nao roda JavaScript passa direto por aqui.

  1. Armadilha: o campo "website" fica escondido da vista. Gente nao preenche,
     robo que preenche tudo preenche. Preenchido, o envio e barrado em silencio.
  2. Tempo: o instante em que o formulario apareceu vai para o campo oculto
     "inicio_preenchimento". Envio em menos de 3 segundos e barrado com aviso,
     porque pessoa nenhuma preenche seis campos nesse tempo.

  Os dois campos ficam fora do prefixo contact[], entao nao chegam a Shopify.
*/
(function () {
  var TEMPO_MINIMO_MS = 3000;

  function proteger(form) {
    var inicio = form.querySelector('input[name="inicio_preenchimento"]');
    var armadilha = form.querySelector('input[name="website"]');
    var aviso = form.querySelector('.formulario__trava');

    if (inicio) inicio.value = String(Date.now());

    form.addEventListener('submit', function (evento) {
      if (armadilha && armadilha.value !== '') {
        evento.preventDefault();
        return;
      }

      var comeco = inicio ? Number(inicio.value) : 0;
      if (comeco && Date.now() - comeco < TEMPO_MINIMO_MS) {
        evento.preventDefault();
        if (aviso) {
          aviso.hidden = false;
          aviso.focus();
        }
        return;
      }

      if (aviso) aviso.hidden = true;
    });
  }

  document.querySelectorAll('form[data-protecao]').forEach(proteger);
})();
